export const LOCATIONS = 'Locations';
export const GROUPS = 'Groups';

export const TABS_LIST = [LOCATIONS, GROUPS];
